import React, { useCallback, useEffect, useState, useRef, createElement } from 'react';
import { Check, Star, AlertTriangle, Hammer, BookOpen, ShieldCheck, Lock, CreditCard, Wrench, Layout, ChevronDown, Zap, Download, HelpCircle, Brain, DollarSign, MessageSquare, X, ChevronLeft, ChevronRight, TrendingUp } from 'lucide-react';
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/a53GoZChi4D4KXXg2vPEsN/naQNb_l4Tge_o_3mPcStbw2k.webp';
const NEW_HERO_IMG = 'https://cdn.magicpatterns.com/uploads/4JGpGnPGrKuWJEhRz4fcSM/Diseno_sin_titulo_(1).png';
const MERCADO_PAGO_CHECKOUT = 'https://cdn.magicpatterns.com/uploads/jkgxfSii45fTiBQ4YfyPYV/mercadopago2.jpg';
const BUNDLE_HERO_IMG = 'https://cdn.magicpatterns.com/uploads/eZ9vqieemzRzScwfScAkC3/_bWADyqANS36Osq2xWSZ4ag_Uhd7XL9ASTiwWyQ4L3RkFA_4k.png';
const MERCADO_PAGO_IMG = 'https://cdn.magicpatterns.com/uploads/xm4qavEQc5iVme5Wmyo3hK/medios-de-pago-640x640.png';
const HEADER_LOGO = 'https://cdn.magicpatterns.com/uploads/bHhkj1c2stkPnwrsvUX5bY/Diseno_sin_titulo_(3).png';
const MAIN_CHECKOUT_URL = 'https://checkout.maestrosindustriales.shop/cart/47957399109880:1';
const STICKY_ICON = 'https://cdn.magicpatterns.com/uploads/bHhkj1c2stkPnwrsvUX5bY/Diseno_sin_titulo_(3).png';
const COMPRA_SEGURA_IMG = 'https://cdn.magicpatterns.com/uploads/s9ioLDDqLpMwzzKeigXiQX/safe-purchase-7779878_1280.png';
const GARANTIA_IMG = 'https://cdn.magicpatterns.com/uploads/oNZ7aT7mecdQjh23Py1dkd/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/tuFoxUDEqhmxQX8maY7Rmk/Mercado_Libre.jpg', 'https://cdn.magicpatterns.com/uploads/pPJvXWY4bJL9dZW8mG2CW1/descarga.jpg', 'https://cdn.magicpatterns.com/uploads/1w3JTtAaPhJNXT5LstEj3s/Carro_de_arrastre.jpg', 'https://cdn.magicpatterns.com/uploads/9Hy3tgreCntYzcxpWPGre4/Estante_Vision_Light.jpg', 'https://cdn.magicpatterns.com/uploads/nBMzSC4jQoptTazs6eMxPf/Idea_for_elevated_shelf_coffee_bar.jpg', 'https://cdn.magicpatterns.com/uploads/79WBidoMhCcGVc2EV4vgM7/a2d8fd5e5a54797f1ead28787fc39cf9.jpg', 'https://cdn.magicpatterns.com/uploads/ijYXMTa5aQAoH4kWS84skC/descarga_(1).jpg', 'https://cdn.magicpatterns.com/uploads/isxqumkJKYCsuGMmceuzLF/d02ffcf8523b664ae13ecd3c80313403.jpg', 'https://cdn.magicpatterns.com/uploads/phyW8vHdEZv7yVwzueRKXE/Custom_Natural_Wood_Bookshelves.jpg'];
const EBOOK_PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/w8C5g6BQpeT4rfYefSxVX2/capture_260131_162524.png', 'https://cdn.magicpatterns.com/uploads/sosZXNubdXe7um5YBtv71j/capture_260131_162625.png', 'https://cdn.magicpatterns.com/uploads/4TxwABQPhvZoSkUXR4NnZK/capture_260131_162636.png', 'https://cdn.magicpatterns.com/uploads/9NSEHn1wM1kuk4rJqZZ6DP/capture_260131_162930.png', 'https://cdn.magicpatterns.com/uploads/6xLj3uTRfgy2HuP6DX9qu1/capture_260131_163022.png', 'https://cdn.magicpatterns.com/uploads/rE6SM2zVSp4LMib3opo6LD/capture_260228_170726.png', 'https://cdn.magicpatterns.com/uploads/hxGkKDiw3VSryFywVv8BXu/capture_260228_170721.png', 'https://cdn.magicpatterns.com/uploads/mmwtyKuXZA6rbSVtDpwBKu/capture_260228_170715.png'];
const BONUS_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/t8xEtDJda4yLe3pxg4aBuu/Diseno_sin_titulo_(3).png',
  title: 'BONO PREMIUM: MÁQUINAS DE GIMNASIO RENTABLES (+200 PLANOS)',
  desc: '+200 PLANOS AHORA de fabricación de máquinas de gimnasio industriales. Edición especial con diseños probados de alta demanda.',
  price: '$45.000 ARS',
  isPremium: true
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bsNuHGEFA4vXVMzB8Zb749/_hvsfq7UVS0ati8NEDewDqw_yRVWzHnITfOLECFjx49Q-g_2k.png',
  title: 'MÓDULO 1: Planos para Muebles Rentables',
  desc: 'Diseños listos para cortar y armar, pensados para productos de alta demanda.',
  price: '$10.700 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p2N8UbnH5SUvSsccZEgq4M/vpRUikLCRcKY6us7VndvfQ2k.webp',
  title: 'MÓDULO 2: Sistema de Presupuesto',
  desc: 'Calculadora para cobrar lo justo y ganar más en cada trabajo.',
  price: '$8.900 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i5QEvD9WY8kDHkpzozLjDt/_D3cFzWo8ST2Ggzz4TBGB4g_yBMj4frJQrOCy_cvImW-6g_2k.png',
  title: 'MÓDULO 3: Manual de Soldadura',
  desc: 'Técnicas fundamentales para lograr estructuras firmes y prolijas.',
  price: '$12.500 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/prJbjXeLzJJTwUZq9js8xs/_xR4h7ZpIQvmpw6Llrpwj3g_G8TJHEpaQc6UK_gxXcX2bQ_2k.png',
  title: 'MÓDULO 4: Formación Teórica',
  desc: 'La base del conocimiento industrial para evitar errores costosos.',
  price: '$9.800 ARS'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gDKgXCpfa8Z5k34F5H4JSS/ikvNh9P4SJ2OiUcz47WycA2k.webp',
  title: 'MÓDULO 5: Proyectos de Trailers y Portones',
  desc: '12 diseños listos para fabricar y vender, incluye planos completos de trailers y portones.',
  price: '$14.200 ARS'
}];
const CURATED_REVIEWS = [{
  name: 'Carlos M.',
  location: 'Buenos Aires',
  rating: 5,
  text: 'Yo laburo en herrería hace años y siempre improvisaba. Con los planos estos arranqué a trabajar más ordenado. Se nota la diferencia.'
}, {
  name: 'Luis R.',
  location: 'Córdoba',
  rating: 5,
  text: 'Pensé que era otro PDF más, pero la verdad están bien explicados y listos para usar. Ya hice dos trabajos sin renegar.'
}, {
  name: 'Martín G.',
  location: 'Rosario',
  rating: 4,
  text: 'Muy bueno, me ayudó a ordenar el laburo. Lo recomiendo.'
}, {
  name: 'Diego P.',
  location: 'Mendoza',
  rating: 5,
  text: 'Muy práctico. Para el que fabrica seguido, esto ahorra tiempo y errores.'
}, {
  name: 'Jorge S.',
  location: 'Santa Fe',
  rating: 5,
  text: 'Excelente material. Los planos de los trailers me sirvieron para agarrar un laburo grande.'
}, {
  name: 'Pablo D.',
  location: 'Tucumán',
  rating: 4,
  text: 'Buen material, lo estoy usando bastante. Cumple con lo que promete.'
}, {
  name: 'Fernando A.',
  location: 'Neuquén',
  rating: 5,
  text: 'Soy hobbista y me animé a hacer mi primera mesa. Quedó espectacular.'
}, {
  name: 'Ricardo V.',
  location: 'Mar del Plata',
  rating: 5,
  text: 'Buena info, directa al grano. Sin vueltas.'
}];
const RECENT_SALES = ['Martín de Buenos Aires', 'José de Ciudad de México', 'Andrés de Bogotá', 'Luis de Lima', 'Pablo de Santiago', 'Ricardo de Montevideo', 'Eduardo de Guadalajara'];
const FAQ_DATA = [{
  q: '¿Necesito experiencia previa para usar los planos?',
  a: 'No. Los planos están pensados tanto para quienes recién empiezan como para herreros con experiencia. Todo está explicado paso a paso, con medidas claras y criterio industrial.'
}, {
  q: '¿Qué tipo de proyectos voy a poder fabricar?',
  a: 'Muebles industriales, estructuras, portones, rejas, trailers y otros proyectos rentables. Son diseños probados y pensados para vender.'
}, {
  q: '¿En qué formato recibo el material?',
  a: 'Todo el contenido se entrega en formato digital (PDF y carpetas organizadas), listo para descargar y usar.'
}, {
  q: '¿El acceso es inmediato?',
  a: 'Sí. Apenas se confirma el pago, recibís el acceso automático al material completo.'
}, {
  q: '¿Puedo usar los planos para trabajar y vender?',
  a: 'Sí. Los planos están pensados para que fabriques y vendas tus propios proyectos sin improvisar.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días de garantía. Si el material no es lo que esperabas, podés solicitar la devolución.'
}];
const useInView = (options = {}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.unobserve(element);
      }
    }, {
      threshold: 0.1,
      ...options
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return {
    ref,
    isInView
  };
};
const ScrollReveal = ({
  children,
  className = '',
  delay = 0,
  type = 'fade-down'
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  type?: 'fade-down' | 'fade-up' | 'fade-left' | 'fade-right' | 'zoom' | 'float-up';
}) => {
  const {
    ref,
    isInView
  } = useInView({
    threshold: 0.15
  });
  const baseDelay = typeof delay === 'number' ? delay * 0.15 : 0;
  const hiddenTransform = type === 'fade-down' ? 'translateY(-12px)' : type === 'fade-up' ? 'translateY(12px)' : type === 'fade-left' ? 'translateX(-12px)' : type === 'fade-right' ? 'translateX(12px)' : type === 'zoom' ? 'scale(0.96)' : 'translateY(12px)';
  return <div ref={ref} className={className} style={{
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0) translateX(0) scale(1)' : hiddenTransform,
    transition: `opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${baseDelay}s, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${baseDelay}s`
  }} data-id="element-0" data-mp="9omq2tdei9iy">
      {children}
    </div>;
};
const MetaPixel = () => {
  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[src*="fbevents.js"]');
    existingScripts.forEach(script => script.remove());
    if ((window as any).fbq) {
      delete (window as any).fbq;
      delete (window as any)._fbq;
    }
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1951517502462967');fbq('track','PageView');fbq('track', 'ViewContent', { content_name: 'Maestro de Muebles Industriales', content_category: 'Digital Product' });`;
    document.head.appendChild(script);
  }, []);
  return null;
};
const SocialProofPopup = () => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = RECENT_SALES[Math.floor(Math.random() * RECENT_SALES.length)];
      setText(`${randomName} acaba de comprar este libro`);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const loop = () => {
      const nextTime = Math.random() * 20000 + 20000;
      setTimeout(() => {
        showPopup();
        loop();
      }, nextTime);
    };
    const loopTimer = setTimeout(loop, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(loopTimer);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-1" data-mp="3mwzhhlvf5v49">
      <div className="bg-neutral-900/95 backdrop-blur border border-green-500/30 text-white px-3 py-2 rounded-lg shadow-xl flex items-center gap-3 max-w-[280px]" data-id="element-2" data-mp="3i092z2z9j7ky">
        <div className="w-8 h-8 rounded-full flex items-center justify-center bg-green-500/20 flex-shrink-0" data-id="element-3" data-mp="3d2qyppw6xgja">
          <Check className="w-5 h-5 text-green-400" data-id="element-4" data-mp="348ccf3d8t5qo" />
        </div>
        <div data-id="element-5" data-mp="348ukqyd6jaey">
          <p className="text-xs font-medium leading-tight" data-id="element-6" data-mp="3468cewigsqvo">{text}</p>
          <p className="text-[10px] text-neutral-400 mt-0.5" data-id="element-7" data-mp="2zaj68abxwbqe">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
};
const ScrollToBuy = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={handleClick} className={`cursor-pointer ${className}`} data-id="element-8" data-mp="2kk6h3kfd5wak">
      {children}
    </div>;
};
const StickyHeader = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 transform ${visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'} bg-neutral-950/95 backdrop-blur-sm border-b border-neutral-800 py-2 shadow-lg`} data-id="element-9" data-mp="2plm2jdlge4th">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-10" data-mp="3hb8p4b6wk5ko">
        <div className="flex items-center gap-2" data-id="element-11" data-mp="3m4jxwhv9ywf8">
          <img src={HEADER_LOGO} alt="Maestro Industrial" className="h-8 md:h-10 w-auto object-contain" data-id="element-12" data-mp="3m5cz73bgstpz" />
          <span className="font-bold text-white text-sm hidden sm:block" data-id="element-13" data-mp="15oeuwiju79wg">
            MAESTRO INDUSTRIAL
          </span>
        </div>
        <ScrollToBuy data-id="element-14" data-mp="1kgfdrvtv6gwp">
          <button className="purchase-cta rounded bg-yellow-500 px-4 py-2 text-xs font-bold text-black transition-[background-color,box-shadow,transform] duration-200 hover:bg-yellow-400" data-id="element-15" data-mp="1ff9o66vi39re">
            <span className="relative z-10" data-id="element-16" data-mp="rri6sov3s6j9">Acceder Ahora</span>
          </button>
        </ScrollToBuy>
      </div>
    </div>;
};
const CTAButton = ({
  text,
  subtext,
  className = '',
  pulse = false
}: {
  text: string;
  subtext?: string;
  className?: string;
  pulse?: boolean;
}) => <div className="w-full" data-id="element-17" data-mp="wqus356bt5jq">
    <ScrollToBuy className="w-full flex justify-center" data-id="element-18" data-mp="2d2rtf7pydtqn">
      <button className={`purchase-cta group w-full max-w-md rounded-lg bg-yellow-400 px-8 py-4 text-center font-black text-neutral-900 transition-[background-color,box-shadow,transform] duration-200 ${pulse ? 'animate-glow-pulse' : ''} ${className}`} data-id="element-19" data-mp="2d16znkbgqetu">
        <span className="relative z-10 flex flex-col items-center justify-center gap-1" data-id="element-20" data-mp="mmxw15yru32x">
          <span className="text-lg md:text-xl uppercase tracking-wide font-black" data-id="element-21" data-mp="qn8bd98ge5ug">
            {text}
          </span>
          {subtext && <span className="text-xs font-normal opacity-90" data-id="element-22" data-mp="vkhygi8de5f4">{subtext}</span>}
        </span>
      </button>
    </ScrollToBuy>
    <p className="mt-2 flex items-center justify-center gap-1.5 text-center text-[11px] font-bold uppercase tracking-wide text-yellow-300/90" data-id="element-23" data-mp="15kio0lwu1hrr">
      <Zap className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="1ac0oz9yuvicq" />
      Descargá tus planos hoy y empezá tu próximo proyecto.
    </p>
  </div>;
const ProjectsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => setCurrentIndex(prev => (prev + 1) % CAROUSEL_IMAGES.length), []);
  const prevSlide = useCallback(() => setCurrentIndex(prev => (prev - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length), []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 1800);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      diff > 0 ? nextSlide() : prevSlide();
    }
    setTimeout(() => setIsPaused(false), 5000);
  };
  return <section className="space-y-8" data-id="element-25" data-mp="2v5hdyxt6p8o7">
      <div className="text-center space-y-2" data-id="element-26" data-mp="2v4elwmk4l06p">
        <ScrollReveal data-id="element-27" data-mp="2v3mqpcufx4gy">
          <h3 className="text-2xl md:text-3xl font-black uppercase text-white" data-id="element-28" data-mp="t87289px64ub">
            Proyectos probados que podés fabricar con los planos
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-29" data-mp="ji42zrs7funj">
          <p className="text-neutral-400 font-medium text-sm md:text-base" data-id="element-30" data-mp="jivyl2lsxsdt">
            Más de 600 diseños reales: muebles industriales, trailers, portones,
            máquinas de gym y más.
          </p>
        </ScrollReveal>
      </div>
      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-sm mx-auto" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-31" data-mp="ag4l6x9d8mjj">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-32" data-mp="1uwre4cgmc35k">
          {CAROUSEL_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-33" data-mp="3key0w36wfima" data-mpi={idx}>
              <img src={img} alt={`Proyecto ${idx + 1}`} className="w-full aspect-[9/16] object-cover" data-id="element-34" data-mp="3fftrpcjz5kvy" />
            </div>)}
        </div>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-35" data-mp="3pd7vocopoh7d">
          {CAROUSEL_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-1.5 h-1.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-36" data-mp="6xxczqec79z3" data-mpi={idx} />)}
        </div>
      </div>
      <p className="text-center text-neutral-500 text-sm" data-id="element-37" data-mp="2ipb366xqi81z">
        👉 Deslizá para ver proyectos reales fabricados con los planos
      </p>
    </section>;
};
const WorkshopRealitySection = () => {
  const {
    ref,
    isInView
  } = useInView({
    threshold: 0.12
  });
  const problems = [{
    icon: Wrench,
    title: 'TENÉS LAS HERRAMIENTAS, PERO NO LAS ESTÁS APROVECHANDO.',
    description: 'Tenés una soldadora, una amoladora y un espacio para trabajar. Pero todavía no encontraste qué productos podrías empezar a fabricar para ofrecer.'
  }, {
    icon: Layout,
    title: 'PERDÉS HORAS CALCULANDO MEDIDAS.',
    description: 'Cada proyecto nuevo significa buscar referencias, sacar medidas y diseñar desde cero. Tiempo que podrías dedicar a fabricar.'
  }, {
    icon: AlertTriangle,
    title: 'UN ERROR DE MEDIDAS TE PUEDE COSTAR CARO.',
    description: 'Cortar mal un perfil, desperdiciar materiales o tener que rehacer una estructura significa perder tiempo y dinero.'
  }, {
    icon: BookOpen,
    title: 'SIEMPRE TERMINÁS FABRICANDO LO MISMO.',
    description: 'Querés ampliar tu catálogo con muebles industriales o máquinas de gimnasio, pero no tenés los planos para dar el siguiente paso.'
  }];
  return <section ref={ref} className="rounded-xl bg-[#141414] px-4 py-8 sm:px-6 md:px-10 md:py-12" data-id="element-38" data-mp="iophjj8roopq">
      <div className="mx-auto max-w-3xl text-center" style={{
      opacity: isInView ? 1 : 0,
      transform: isInView ? 'translateY(0)' : 'translateY(12px)',
      transition: 'opacity 0.5s ease-out, transform 0.5s ease-out'
    }} data-id="element-39" data-mp="dvcwtk77l229">
        <p className="text-xs font-black uppercase tracking-[0.16em] text-red-400" data-id="element-40" data-mp="3w20z72avjb48">
          LA REALIDAD DEL TALLER
        </p>
        <h2 className="mt-3 text-3xl font-black uppercase leading-[0.95] tracking-tight text-white md:text-5xl" data-id="element-41" data-mp="3r5tqx2v09nj4">
          SABÉS SOLDAR.
          <span className="mt-1 block" data-id="element-42" data-mp="1pcw5hs3k5x87">¿PERO SABÉS QUÉ FABRICAR PARA VENDER?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-neutral-300 md:text-base" data-id="element-43" data-mp="1kdj9ohuplfth">
          Tenés las herramientas, las ganas de trabajar y la experiencia. Pero hay problemas que pueden estar frenando tu próximo proyecto.
        </p>
      </div>

      <div className="mx-auto mt-7 grid max-w-4xl gap-3 md:grid-cols-2 md:gap-4" data-id="element-44" data-mp="27accu7067dlg">
        {problems.map((problem, index) => {
        const Icon = problem.icon;
        return <article key={problem.title} className="rounded-xl border border-neutral-700/70 bg-[#242424] p-5" style={{
          opacity: isInView ? 1 : 0,
          transform: isInView ? 'translateY(0)' : 'translateY(12px)',
          transition: `opacity 0.5s ease-out ${0.1 + index * 0.07}s, transform 0.5s ease-out ${0.1 + index * 0.07}s`
        }} data-id="element-45" data-mp="1xhwsx45bcexx" data-mpi={index}>
              <Icon className="h-5 w-5 text-red-400" aria-hidden="true" data-id="element-46" data-mp="3dwpool1kx9oj" />
              <h3 className="mt-3 text-sm font-black uppercase leading-snug text-white md:text-base" data-id="element-47" data-mp="3dulp2fapqwu2">
                {problem.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-300" data-id="element-48" data-mp="3hff2hf55uctk">
                {problem.description}
              </p>
            </article>;
      })}
      </div>

      <div className="mx-auto mt-6 max-w-4xl space-y-4 border-y border-neutral-700/70 py-5" style={{
      opacity: isInView ? 1 : 0,
      transform: isInView ? 'translateY(0)' : 'translateY(12px)',
      transition: 'opacity 0.5s ease-out 0.38s, transform 0.5s ease-out 0.38s'
    }} data-id="element-49" data-mp="3q6fe865aj83n">
        <div className="flex items-start gap-3" data-id="element-50" data-mp="32i4j7jma02na">
          <X className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden="true" data-id="element-51" data-mp="37gftfvghgf61" />
          <div data-id="element-52" data-mp="37iiv5cqzzwql">
            <h3 className="text-sm font-black uppercase text-white md:text-base" data-id="element-53" data-mp="3cfiyhfwgqle0">LOS QUE IMPROVISAN</h3>
            <p className="mt-1 text-sm leading-relaxed text-neutral-300" data-id="element-54" data-mp="mq75mr83xfbg">
              <span className="font-medium text-red-400" data-id="element-55" data-mp="msb8r6y6maao">Pierden tiempo calculando medidas</span>, desperdician materiales y empiezan cada proyecto desde cero.
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3" data-id="element-56" data-mp="23907zfl3a7i">
          <Check className="mt-0.5 h-5 w-5 shrink-0 text-green-500" aria-hidden="true" data-id="element-57" data-mp="3t88vjq7l8t53" />
          <div data-id="element-58" data-mp="bzvhyfcm5l5b">
            <h3 className="text-sm font-black uppercase text-white md:text-base" data-id="element-59" data-mp="byaqwzpickc7">LOS QUE TRABAJAN CON PLANOS</h3>
            <p className="mt-1 text-sm leading-relaxed text-neutral-300" data-id="element-60" data-mp="70segzca7mzg">
              Tienen <span className="font-medium text-green-400" data-id="element-61" data-mp="3fh40z2j2ur1m">medidas de referencia</span>, ahorran tiempo de diseño y pueden elegir entre cientos de proyectos para fabricar.
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-6 max-w-4xl rounded-xl border border-yellow-400/40 bg-[#101010] px-5 py-7 text-center md:px-8" style={{
      opacity: isInView ? 1 : 0,
      transform: isInView ? 'translateY(0)' : 'translateY(12px)',
      transition: 'opacity 0.5s ease-out 0.5s, transform 0.5s ease-out 0.5s'
    }} data-id="element-62" data-mp="3p76qutuwjovq">
        <h3 className="text-2xl font-black uppercase leading-[0.95] text-yellow-400 md:text-4xl" data-id="element-63" data-mp="1785uphf3i4ss">
          NO TE FALTAN HERRAMIENTAS.
          <span className="mt-1 block" data-id="element-64" data-mp="1c0gvemhntume">TE FALTAN PROYECTOS.</span>
        </h3>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white md:text-base" data-id="element-65" data-mp="xbb21f5i6ymf">
          Accedé a más de 1.100 planos de fabricación para elegir tu próximo producto y empezar a trabajar sin diseñar todo desde cero.
        </p>
      </div>
    </section>;
};
const BonusesSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [bonusCupos, setBonusCupos] = useState(13);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    // Decrement bonus cupos from 13 to 2, synced pace with payment card
    const timers: ReturnType<typeof setTimeout>[] = [];
    const scheduleNext = () => {
      const t = setTimeout(() => {
        setBonusCupos(prev => {
          if (prev > 2) return prev - 1;
          return prev;
        });
        scheduleNext();
      }, 40000 + Math.random() * 60000);
      timers.push(t);
    };
    scheduleNext();
    return () => timers.forEach(clearTimeout);
  }, []);
  const itemsPerSlide = isMobile ? 1 : 2;
  const maxIndex = Math.ceil(BONUS_IMAGES.length / itemsPerSlide) - 1;
  const nextSlide = useCallback(() => setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1), [maxIndex]);
  const prevSlide = useCallback(() => setCurrentIndex(prev => prev <= 0 ? maxIndex : prev - 1), [maxIndex]);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      diff > 0 ? nextSlide() : prevSlide();
    }
  };
  return <section className="space-y-12" data-id="element-66" data-mp="23xolln9vbf6e">
      <div className="text-center space-y-2" data-id="element-67" data-mp="28q82at3uqqff">
        <ScrollReveal data-id="element-68" data-mp="28s2k3yjtu2fa">
          <span className="inline-block bg-neutral-800 border border-yellow-500/50 text-yellow-500 text-xs font-bold uppercase px-4 py-1 rounded-full" data-id="element-69" data-mp="28scdlw42yrpq">
            ACCESO ESPECIAL DISPONIBLE HOY
          </span>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-70" data-mp="2mpr99ikxfvq5">
          <h3 className="text-3xl md:text-4xl font-black text-yellow-500 uppercase" data-id="element-71" data-mp="2mqsj5jq7ic6a">
            ACCESO COMPLETO + 6 BONOS INCLUIDOS
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={2} data-id="element-72" data-mp="sd1cmt36c8f2">
          <p className="text-neutral-400 font-medium" data-id="element-73" data-mp="sdsznfipgxtq">
            Todo lo que recibís con tu acceso
          </p>
          <p className="text-neutral-500 text-xs mt-2" data-id="element-74" data-mp="xdfbbkivy60f">
            Oferta de bonos válida solo por hoy:{' '}
            {new Date().toLocaleDateString('es-AR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </ScrollReveal>
      </div>
      <div className="relative px-4 md:px-12" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-75" data-mp="24nts2d44l51c">
        <div className="overflow-hidden" data-id="element-76" data-mp="2jj0015ms7dxb">
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * 100}%)`
        }} data-id="element-77" data-mp="2emje8i321bne">
            {Array.from({
            length: Math.ceil(BONUS_IMAGES.length / itemsPerSlide)
          }).map((_, slideIndex) => <div key={slideIndex} className="w-full flex-shrink-0 flex gap-6 px-1" data-id="element-78" data-mp="32c3ugt7tpusz" data-mpi={slideIndex}>
                {BONUS_IMAGES.slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide).map((bonus: any, idx: number) => <div key={idx} className={`w-full ${isMobile ? 'flex-1' : 'w-1/2'}`} data-id="element-79" data-mp="3lv1gwumil5h3" data-mpi={idx}>
                    {bonus.isPremium ? <ScrollToBuy className="h-full group relative bg-neutral-950 rounded-xl overflow-hidden border-2 border-red-500 shadow-2xl animate-border-blink-red flex flex-col" data-id="element-80" data-mp="3c1avjylopb5m">
                        {/* Animated fire gradient background */}
                        <div className="absolute inset-0 animate-fire-gradient pointer-events-none z-0" data-id="element-81" data-mp="2oaex4imq3hpe" />
                        <div className="absolute top-4 left-4 z-20" data-id="element-82" data-mp="2t9rrrpju5t2j">
                          <span className="inline-block bg-red-600 text-white text-xs font-black uppercase px-4 py-1.5 rounded-full shadow-lg shadow-red-500/30 animate-premium-badge-pulse" data-id="element-83" data-mp="2f97awyxhe7bo">
                            ⭐ BONO PREMIUM
                          </span>
                        </div>
                        <div className="relative z-10 w-full aspect-[4/3] bg-neutral-900" data-id="element-84" data-mp="2ur891tig6aqo">
                          <img src={bonus.src} alt={bonus.title} className="w-full h-full object-cover" data-id="element-85" data-mp="2prvm78rkt3o3" />
                        </div>
                        <div className="relative z-10 p-6 space-y-4 bg-neutral-900/90 border-t border-red-500/30 flex-1 flex flex-col" data-id="element-86" data-mp="2grz5pufcbb44">
                          <div className="flex-1" data-id="element-87" data-mp="2bye7c19u4f4e">
                            <h4 className="text-xl font-black text-white mb-2 uppercase" data-id="element-88" data-mp="272flolfw5b7o">
                              {'BONO PREMIUM: M\xC1QUINAS DE GIMNASIO RENTABLES (+500 PLANOS)'}
                            </h4>
                            <p className="text-neutral-300 text-sm" data-id="element-89" data-mp="1t137ofkajjof">
                              <span className="text-yellow-400 font-black" data-id="element-90" data-mp="1t3z6e63yqcdx">
                                +500 PLANOS AHORA
                              </span>{' '}
                              de fabricación de máquinas de gimnasio
                              industriales. Edición especial con diseños
                              probados de alta demanda.
                            </p>
                          </div>
                          <div className="flex items-center gap-2 py-2" data-id="element-91" data-mp="3l1hd94l4qdgx">
                            <span className="relative flex items-center justify-center" style={{
                      width: 12,
                      height: 12
                    }} data-id="element-92" data-mp="3q023cb6o3grn">
                              <span className="absolute inset-0 rounded-full bg-red-500 animate-led-blink" data-id="element-93" data-mp="32ahmpyxzkvlj"></span>
                              <span className="relative rounded-full bg-red-400" style={{
                        width: 8,
                        height: 8
                      }} data-id="element-94" data-mp="379155pddfp95"></span>
                            </span>
                            <span className="text-red-400 text-xs font-black uppercase" data-id="element-95" data-mp="27ypd6248raqc">
                              ¡ÚLTIMOS {bonusCupos} CUPOS DISPONIBLES CON ESTE
                              BONO!
                            </span>
                          </div>
                          <div className="flex items-center justify-between pt-3 border-t border-neutral-700" data-id="element-96" data-mp="230xix1g4jciz">
                            <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-97" data-mp="1ocaxqj3tfqju">
                              {bonus.price}
                            </span>
                            <div className="flex items-center gap-1.5 bg-red-500/20 px-4 py-1.5 rounded border border-red-500/40 animate-incluido-glow" data-id="element-98" data-mp="1fa1mts4mxv5x">
                              <Check className="w-3.5 h-3.5 text-red-400 animate-check-bounce" data-id="element-99" data-mp="1kbh9tpqdibqy" />
                              <span className="text-red-400 text-xs font-black uppercase" data-id="element-100" data-mp="10pp4w2c8bqc2">
                                INCLUIDO HOY
                              </span>
                            </div>
                          </div>
                        </div>
                      </ScrollToBuy> : <ScrollToBuy className="h-full group bg-neutral-900 rounded-xl overflow-hidden border border-yellow-500 shadow-lg shadow-yellow-500/5 flex flex-col" data-id="element-101" data-mp="1jm7578558yjx">
                        <div className="w-full aspect-[4/3] bg-neutral-900" data-id="element-102" data-mp="1el9jwmou7oe7">
                          <img src={bonus.src} alt={bonus.title} className="w-full h-full object-cover" data-id="element-103" data-mp="1tbqjs1ltq68z" />
                        </div>
                        <div className="p-6 space-y-4 bg-neutral-800/50 border-t border-neutral-800 flex-1 flex flex-col" data-id="element-104" data-mp="1xe57az0ftu6l">
                          <div className="flex-1" data-id="element-105" data-mp="v18ol1rofpyw">
                            <h4 className="text-lg font-black text-white mb-2 uppercase" data-id="element-106" data-mp="uymeaudeiwcz">
                              {bonus.title}
                            </h4>
                            <p className="text-neutral-400 text-sm" data-id="element-107" data-mp="13zklflj4zjzs">
                              {bonus.desc}
                            </p>
                          </div>
                          <div className="flex items-center justify-between pt-3 border-t border-neutral-700" data-id="element-108" data-mp="1drqb2olx1pbt">
                            <span className="text-neutral-500 line-through text-sm font-bold" data-id="element-109" data-mp="1ioysgmz8ppc0">
                              {bonus.price}
                            </span>
                            <div className="flex items-center gap-1.5 bg-green-500/10 px-3 py-1 rounded border border-green-500/20" data-id="element-110" data-mp="1rr845g68voqz">
                              <Check className="w-3 h-3 text-green-500" data-id="element-111" data-mp="3phsvizsb55ky" />
                              <span className="text-green-500 text-xs font-black uppercase" data-id="element-112" data-mp="3thb8n9dw0cd8">
                                INCLUIDO
                              </span>
                            </div>
                          </div>
                        </div>
                      </ScrollToBuy>}
                  </div>)}
              </div>)}
          </div>
        </div>
        <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-neutral-900/80 p-2 rounded-full border border-neutral-700 text-white hover:bg-neutral-800 transition-colors z-20 hidden md:block" data-id="element-113" data-mp="388gjsfqsigkw">
          <ChevronLeft className="w-6 h-6" data-id="element-114" data-mp="3vwhplgwl3iwm" />
        </button>
        <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-neutral-900/80 p-2 rounded-full border border-neutral-700 text-white hover:bg-neutral-800 transition-colors z-20 hidden md:block" data-id="element-115" data-mp="3vuwvfse6m1za">
          <ChevronRight className="w-6 h-6" data-id="element-116" data-mp="2fhykzqx3n1da" />
        </button>
        <div className="mt-6 flex flex-col items-center gap-3" data-id="element-117" data-mp="2fkkptislv2rt">
          <div className="flex justify-center gap-2" data-id="element-118" data-mp="7908kg5t82po">
            {Array.from({
            length: Math.ceil(BONUS_IMAGES.length / itemsPerSlide)
          }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-yellow-500' : 'w-2 bg-neutral-700'}`} data-id="element-119" data-mp="3ufj3054zl7ea" data-mpi={idx} />)}
          </div>
          <p className="text-white text-[13px] flex items-center gap-2 animate-pulse" data-id="element-120" data-mp="uzmhsarjvt19">
            Desliza para ver todos los bonos{' '}
            <span className="animate-arrow-vibrate" data-id="element-121" data-mp="gzbpd3ale6dz">⮕</span>
          </p>
        </div>
      </div>
    </section>;
};
const CompactAccessSection = () => <section className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 md:p-8" data-id="element-122" data-mp="31pas8ycs5p9q">
    <div className="text-center mb-6" data-id="element-123" data-mp="36ongnnjav4ef">
      <ScrollReveal data-id="element-124" data-mp="36poprmgr9gti">
        <span className="inline-block bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs font-bold uppercase px-3 py-1 rounded-full mb-3" data-id="element-125" data-mp="36q86x0yl016h">
          ACCESO COMPLETO DISPONIBLE HOY
        </span>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-126" data-mp="385u78tsbvuph">
        <h3 className="text-xl md:text-2xl font-black text-white uppercase" data-id="element-127" data-mp="38518og3iwbif">
          MAESTRO DE MUEBLES INDUSTRIALES 2026 +{' '}
          <span className="text-yellow-500" data-id="element-128" data-mp="337sqifidk7h6">6 BONOS</span>
        </h3>
      </ScrollReveal>
    </div>
    <ScrollReveal delay={2} type="fade-up" data-id="element-129" data-mp="2fhoo2bgxadrr">
      <div className="mb-8" data-id="element-130" data-mp="2aiu2x2vhgd4h">
        <img src={BUNDLE_HERO_IMG} alt="Pack Completo con Bonos" className="w-[90%] mx-auto rounded-lg" data-id="element-131" data-mp="2ajmzxc4n3o9f" />
      </div>
    </ScrollReveal>
    <ScrollReveal delay={3} data-id="element-132" data-mp="2kg8826byhfhh">
      <p className="text-neutral-400 text-sm mt-2 max-w-lg mx-auto text-center mb-6" data-id="element-133" data-mp="2kex528qc4brf">
        Accedés al sistema completo de planos industriales para fabricar con
        método, cobrar como profesional y dejar de improvisar.
      </p>
    </ScrollReveal>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-134" data-mp="3rubuz0kd7gxf">
      {['Ebook Maestro de Muebles Industriales', '+600 planos industriales listos para fabricar', 'Sistema de presupuesto y cierre', 'Manual de soldadura + formación teórica', 'Proyectos especiales: trailers y portones', '+500 planos de máquinas de gimnasio', '6 bonos extra incluidos hoy'].map((item, i) => <ScrollReveal key={i} delay={4 + i} data-id="element-135" data-mp="38x2dhoylodit" data-mpi={i}>
          <div className="flex items-center gap-2" data-id="element-136" data-mp="3du18sau02qil">
            <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-137" data-mp="3dukpjo7wz8v1" />
            <span className="text-neutral-300 text-sm" data-id="element-138" data-mp="3hvmmfyecz8tu">{item}</span>
          </div>
        </ScrollReveal>)}
    </div>
  </section>;
const DynamicPurchaseCard = () => {
  const [displayViewers, setDisplayViewers] = useState(48);
  const [spots, setSpots] = useState(13);
  const [members, setMembers] = useState(5462);
  const [currentDate, setCurrentDate] = useState('');
  const [viewerFade, setViewerFade] = useState(false);
  const viewerIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const spotsIntervalRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    setCurrentDate(new Date().toLocaleDateString('es-AR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }));
    const storedSpots = localStorage.getItem('promo_spots_v3');
    const storedMembers = localStorage.getItem('promo_members_v3');
    const storedTime = localStorage.getItem('promo_time_v3');
    const now = Date.now();
    if (storedSpots && storedMembers && storedTime && now - parseInt(storedTime) <= 86400000) {
      setSpots(Math.max(2, parseInt(storedSpots)));
      setMembers(parseInt(storedMembers));
    } else {
      setSpots(13);
      setMembers(5462);
      localStorage.setItem('promo_spots_v3', '13');
      localStorage.setItem('promo_members_v3', '5462');
      localStorage.setItem('promo_time_v3', String(now));
    }
    const iv = 35 + Math.floor(Math.random() * 28);
    setDisplayViewers(iv);
    viewerIntervalRef.current = setInterval(() => {
      setViewerFade(true);
      setTimeout(() => {
        setDisplayViewers(prev => {
          const change = Math.floor(Math.random() * 9) - 4;
          let next = prev + change;
          if (next < 35) next = 35 + Math.floor(Math.random() * 5);
          if (next > 62) next = 62 - Math.floor(Math.random() * 5);
          return next;
        });
        setViewerFade(false);
      }, 150);
    }, 3000);
    const updateSpots = () => {
      setSpots(prev => {
        if (prev > 2) {
          const nv = prev - 1;
          localStorage.setItem('promo_spots_v3', String(nv));
          setMembers(prevM => {
            const nm = prevM + 1;
            localStorage.setItem('promo_members_v3', String(nm));
            return nm;
          });
          return nv;
        }
        return prev;
      });
      spotsIntervalRef.current = setTimeout(updateSpots, 40000 + Math.random() * 60000);
    };
    spotsIntervalRef.current = setTimeout(updateSpots, 40000 + Math.random() * 60000);
    return () => {
      if (viewerIntervalRef.current) clearInterval(viewerIntervalRef.current);
      if (spotsIntervalRef.current) clearTimeout(spotsIntervalRef.current);
    };
  }, []);
  const handleMainCheckout = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Maestro de Muebles Industriales',
        content_category: 'Ebook',
        value: 19990.0,
        currency: 'ARS'
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Maestro de Muebles Industriales',
        value: 19990.0,
        currency: 'ARS'
      });
    }
    window.location.href = MAIN_CHECKOUT_URL;
  };
  return <div id="compra" className="w-full max-w-2xl mx-auto" data-id="element-139" data-mp="339f4mzhjomv6">
      <div className="bg-neutral-950 rounded-xl border-2 border-yellow-500 shadow-2xl overflow-hidden animate-neon-yellow" data-id="element-140" data-mp="33ayjqmrgsrvd">
        {/* Offer header */}
        <div className="bg-neutral-900 py-4 px-4 text-center border-b border-yellow-500/30" data-id="element-141" data-mp="1djwocwrh827c">
          <h2 className="text-yellow-400 font-black text-xl md:text-2xl uppercase tracking-wide" data-id="element-142" data-mp="1rje8gytturad">
            OFERTA VÁLIDA
          </h2>
          <p className="text-white text-sm mt-1" data-id="element-143" data-mp="1nfq04dxdfro2">Solo por hoy: {currentDate}</p>
        </div>

        <div className="p-6 md:p-8 space-y-6" data-id="element-144" data-mp="21fhisryu1w8e">
          {/* Pricing */}
          <div className="text-center space-y-2" data-id="element-145" data-mp="1wir3i6uur4o1">
            <img src="https://cdn.magicpatterns.com/uploads/cVoCwCY2mco6sa5T2VzTn7/ChatGPT_Image_25_sept_2026,_20_42_05.webp" alt="Maestro de Muebles Industriales" className="w-full max-w-md mx-auto rounded-lg" data-id="element-146" data-mp="1wfv2uarme1vw" />
            <p className="text-neutral-500 text-lg line-through decoration-neutral-600 decoration-2 font-bold" data-id="element-147" data-mp="2k8bp6xie4g10">
              $59.900 ARS
            </p>
            <div className="flex items-baseline justify-center gap-2" data-id="element-148" data-mp="2yuigd4cpgoj4">
              <span className="text-5xl md:text-7xl font-black tracking-tight animate-number-glow text-[#59FF34]" data-id="element-149" data-mp="2ys5zyvmlim86">
                $19.990
              </span>
              <span className="text-xl font-bold text-yellow-400" data-id="element-150" data-mp="2psj0ifdffqhr">ARS</span>
            </div>
          </div>

          {/* Body text */}
          <p className="text-white text-center text-sm md:text-base leading-relaxed max-w-md mx-auto" data-id="element-151" data-mp="2tx8vm209h11m">
            Llevate el Manual Principal + más de{' '}
            <span className="font-black text-yellow-400" data-id="element-152" data-mp="2kvj3sv2gw03b">
              500 PLANOS DE MÁQUINAS DE GYM
            </span>{' '}
            + 5 bonos extras de regalo
          </p>

          {/* Cuotas */}
          <div className="flex justify-center" data-id="element-153" data-mp="2b5ps7u2brkz2">
            <div className="inline-flex items-center gap-2 bg-neutral-900 px-5 py-2.5 rounded-full border border-neutral-700" data-id="element-154" data-mp="2b2bnwga3p1oz">
              <CreditCard className="w-4 h-4 text-green-500" data-id="element-155" data-mp="224hupe7muo61" />
              <span className="text-sm font-medium text-neutral-300" data-id="element-156" data-mp="225syvf4zpxxo">
                Hasta 3 cuotas sin interés
              </span>
            </div>
          </div>

          {/* Urgency counters */}
          <div className="bg-neutral-900/80 backdrop-blur border border-neutral-700 rounded-xl px-5 py-4 space-y-3" data-id="element-157" data-mp="2v880p05szrm">
            <div className="flex items-center gap-3" data-id="element-158" data-mp="3q20t83s7gfmz">
              <span className="relative flex items-center justify-center" style={{
              width: 14,
              height: 14
            }} data-id="element-159" data-mp="3q3bu9vu9n9ae">
                <span className="absolute inset-0 rounded-full bg-green-500 animate-led-blink" data-id="element-160" data-mp="loc74pw5c4tm"></span>
                <span className="relative rounded-full bg-green-400" style={{
                width: 10,
                height: 10
              }} data-id="element-161" data-mp="ho20db0j5adp"></span>
              </span>
              <span className={`text-sm font-bold text-white transition-opacity duration-150 ${viewerFade ? 'opacity-50' : 'opacity-100'}`} data-id="element-162" data-mp="2xck3xezvteuz">
                {displayViewers} personas viendo esta página ahora
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-163" data-mp="1lvqzb0c5bifv">
              <span className="relative flex items-center justify-center" style={{
              width: 14,
              height: 14
            }} data-id="element-164" data-mp="1luxrrx5d4owo">
                <span className="absolute inset-0 rounded-full bg-red-500 animate-led-blink" data-id="element-165" data-mp="1vlajc9blhicb"></span>
                <span className="relative rounded-full bg-red-400" style={{
                width: 10,
                height: 10
              }} data-id="element-166" data-mp="20isix93q2l7n"></span>
              </span>
              <span className="text-sm font-bold text-white" data-id="element-167" data-mp="b5ys8oe88zer">
                Quedan {spots} cupos con precio promocional
              </span>
            </div>
          </div>

          {/* Members box */}
          <div className="bg-neutral-900 border border-yellow-500/30 rounded-xl py-5 px-6 text-center pt-[0px] pb-[0px]" data-id="element-168" data-mp="3g28eadfoigc1">
            <p className="md:text-5xl font-black text-yellow-400 tracking-tight animate-neon-text-glow text-[24px]" data-id="element-169" data-mp="3bzv6zklaaad5">
              +{members.toLocaleString('es-AR')}
            </p>
            <p className="text-white font-bold text-xs uppercase tracking-widest mt-1" data-id="element-170" data-mp="3l13624vmjf8a">
              PERSONAS YA ACCEDIERON
            </p>
          </div>

          {/* CTA Button */}
          <div className="w-full" data-id="element-171" data-mp="2sd78kxy8djag">
            <button onClick={handleMainCheckout} className="purchase-cta w-full rounded-xl bg-yellow-400 py-[30px] text-[20px] font-black uppercase tracking-wide text-black transition-[background-color,box-shadow,transform] duration-200 hover:bg-yellow-300" data-id="element-172" data-mp="2se8ll7yt4fut">
              <span className="relative z-10" data-id="element-173" data-mp="2ek7un0e3jx50">SÍ, QUIERO ACCEDER</span>
            </button>
            <p className="mt-2 flex items-center justify-center gap-1.5 text-center text-[11px] font-bold uppercase tracking-wide text-yellow-300/90" data-id="element-174" data-mp="29lehxa6mwa5w">
              <Zap className="h-3.5 w-3.5" aria-hidden="true" data-id="element-175" data-mp="p2kdps06zfly" />
              Descargá tus planos hoy y empezá tu próximo proyecto.
            </p>
          </div>

          {/* Medios de pago */}
          <div className="border-t border-neutral-800 pt-5" data-id="element-176" data-mp="g1w1n2uczpbp">
            <p className="text-neutral-500 text-xs uppercase tracking-widest text-center mb-3 font-bold" data-id="element-177" data-mp="k63sp6oahhd3">
              MEDIOS DE PAGO
            </p>
            <div className="flex justify-center" data-id="element-178" data-mp="1ctzo8824h38a">
              <div className="w-full max-w-[300px] bg-white rounded-lg p-2" data-id="element-179" data-mp="1ctg20f5fvsog">
                <img src={MERCADO_PAGO_CHECKOUT} alt="Mercado Pago" className="w-full object-contain" data-id="element-180" data-mp="yt5ad9wb2a28" />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 text-left border-t border-neutral-800 pt-6" data-id="element-181" data-mp="3jiuqrrcnq3x1">
            <div className="bg-neutral-950/80 p-5 rounded-xl border border-neutral-700/50 flex items-center gap-5" data-id="element-182" data-mp="3ol3kwr19nc0q">
              <div className="shrink-0 bg-green-900/30 rounded-xl flex items-center justify-center" style={{
              width: 80,
              height: 80
            }} data-id="element-183" data-mp="1u5elaytukx6q">
                <img src={COMPRA_SEGURA_IMG} alt="Compra Segura" className="object-contain" style={{
                width: '75%',
                height: '75%'
              }} data-id="element-184" data-mp="1gc5ixi4bhbxp" />
              </div>
              <div data-id="element-185" data-mp="11ed5cvibyxm5">
                <h4 className="font-black text-white text-base uppercase mb-1.5 tracking-wide" data-id="element-186" data-mp="11fo4uj4qtj7g">
                  PAGO 100% ENCRIPTADO
                </h4>
                <p className="text-neutral-300 text-sm leading-relaxed" data-id="element-187" data-mp="xfdxb21aykqh">
                  Procesamos tu compra a través de plataformas líderes con
                  seguridad SSL para proteger tus datos en todo momento.
                </p>
              </div>
            </div>
            <div className="bg-neutral-950/80 p-5 rounded-xl border border-neutral-700/50 flex items-center gap-5" data-id="element-188" data-mp="dj1cqer8ef9h">
              <div className="shrink-0 bg-green-900/30 rounded-xl flex items-center justify-center" style={{
              width: 80,
              height: 80
            }} data-id="element-189" data-mp="ig1ieok65g02">
                <img src={GARANTIA_IMG} alt="Garantía 7 Días" className="object-contain" style={{
                width: '75%',
                height: '75%'
              }} data-id="element-190" data-mp="3qql5x67z2ql4" />
              </div>
              <div data-id="element-191" data-mp="8kq3a54um6rs">
                <h4 className="font-black text-white text-base uppercase mb-1.5 tracking-wide" data-id="element-192" data-mp="8kzshqi2k9wf">
                  GARANTÍA SIN RIESGO
                </h4>
                <p className="text-neutral-300 text-sm leading-relaxed" data-id="element-193" data-mp="1jzdawfu1zx52">
                  Tenés 7 días para validar la calidad del material. Si el
                  contenido no coincide con lo detallado en esta página, te
                  devolvemos el 100% de tu inversión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const ReviewsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [newReview, setNewReview] = useState({
    name: '',
    text: '',
    rating: 5
  });
  const [hoverRating, setHoverRating] = useState(0);
  const [userReview, setUserReview] = useState<{
    name: string;
    text: string;
    rating: number;
  } | null>(null);
  const [toast, setToast] = useState(false);
  const visibleReviews = showAll ? CURATED_REVIEWS : CURATED_REVIEWS.slice(0, 3);
  const remainingCount = CURATED_REVIEWS.length - 3;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReview.name.trim() || !newReview.text.trim()) return;
    setUserReview({
      ...newReview
    });
    setNewReview({
      name: '',
      text: '',
      rating: 5
    });
    setShowForm(false);
    setToast(true);
    setTimeout(() => setToast(false), 3000);
  };
  return <section className="pt-12 pb-4 bg-neutral-900 text-white border-t border-neutral-800 relative" data-id="element-194" data-mp="31aiqy1shaxu1">
      {toast && <div className="fixed top-24 left-1/2 -translate-x-1/2 bg-neutral-800 border border-green-500/50 text-white px-6 py-4 rounded-lg shadow-2xl z-50 flex items-center gap-3" data-id="element-195" data-mp="367ss2ep8cxxp">
          <div className="bg-green-500/20 p-1 rounded-full" data-id="element-196" data-mp="2wb677pwwm6vo">
            <Check className="w-5 h-5 text-green-500" data-id="element-197" data-mp="2w8jqp0s1ch1b" />
          </div>
          <p className="font-medium text-sm" data-id="element-198" data-mp="2icpr58d5j40v">Gracias por tu comentario</p>
        </div>}
      <div className="max-w-4xl mx-auto px-4" data-id="element-199" data-mp="2narjyl0dqhpj">
        <div className="text-center mb-12 space-y-4" data-id="element-200" data-mp="gk1iuklnhqe8">
          <ScrollReveal data-id="element-201" data-mp="gkbaecmcg5m1">
            <h3 className="text-3xl font-black text-white uppercase" data-id="element-202" data-mp="ghxj8eusbdjr">
              Lo que dicen quienes ya fabrican con método
            </h3>
          </ScrollReveal>
          <ScrollReveal delay={1} data-id="element-203" data-mp="1nc2fh8ch23re">
            <div className="flex flex-col items-center gap-1" data-id="element-204" data-mp="1s9lqlzdvi0f4">
              <p className="text-xl font-medium text-white" data-id="element-205" data-mp="1sa3tvfyydewj">
                Más de 5.600 herreros satisfechos
              </p>
              <div className="flex gap-1" data-id="element-206" data-mp="1x6uac4eo6cih">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-207" data-mp="221hyu39ob6x2" />)}
              </div>
              <p className="text-sm text-neutral-400" data-id="element-208" data-mp="2ay8uwfo86lrn">
                4,9/5 · reseñas verificadas
              </p>
            </div>
          </ScrollReveal>
        </div>

        <div className="space-y-4 mb-8" data-id="element-209" data-mp="2kx87g9c431jx">
          {userReview && <div className="bg-neutral-800 p-6 rounded border border-yellow-500/30" data-id="element-210" data-mp="llf5rzedp80v">
              <div className="flex gap-1 mb-3" data-id="element-211" data-mp="qk8kfv5ej52m">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < userReview.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-212" data-mp="33ui454korq3p" data-mpi={idx} />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-213" data-mp="2v39ganw9btjh">
                "{userReview.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-214" data-mp="2q4ek8k9a48hf">
                <div className="w-8 h-8 bg-yellow-500/20 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-yellow-500/30" data-id="element-215" data-mp="3mt42wcsqd54g">
                  {userReview.name.charAt(0)}
                </div>
                <div data-id="element-216" data-mp="3dredtdmbmi9u">
                  <p className="font-bold text-sm text-white" data-id="element-217" data-mp="3dquw9y0l1vwc">
                    {userReview.name}
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-218" data-mp="38vz5f1731ekt">Tu reseña</p>
                </div>
              </div>
            </div>}

          {visibleReviews.map((review, i) => <div key={i} className="bg-neutral-800 p-6 rounded border border-neutral-700" data-id="element-219" data-mp="1xgiphl39sqna" data-mpi={i}>
              <div className="flex gap-1 mb-3" data-id="element-220" data-mp="23v7wf2snaygd">
                {[...Array(5)].map((_, idx) => <Star key={idx} className={`w-4 h-4 ${idx < review.rating ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-221" data-mp="1pvg9udo2c9qr" data-mpi={idx} />)}
              </div>
              <p className="text-neutral-300 mb-4 italic" data-id="element-222" data-mp="1g4bxllprv2zm">"{review.text}"</p>
              <div className="flex items-center gap-3" data-id="element-223" data-mp="1kw3ndu13t4op">
                <div className="w-8 h-8 bg-neutral-700 rounded-full flex items-center justify-center text-yellow-500 font-bold text-xs border border-neutral-600" data-id="element-224" data-mp="1kxoknresz1q9">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-225" data-mp="x5pu606s8zsj">
                  <p className="font-bold text-sm text-white" data-id="element-226" data-mp="x7aqnvcnqst1">{review.name}</p>
                  <p className="text-xs text-neutral-500" data-id="element-227" data-mp="125vo5n0iyyds">{review.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-228" data-mp="iln6492jlm9n">
          {!showAll && remainingCount > 0 && <button onClick={() => setShowAll(true)} className="text-neutral-400 hover:text-white text-sm font-medium transition-colors" data-id="element-229" data-mp="dmtxaty7ajft">
              Ver {remainingCount} comentarios más
            </button>}

          {!userReview && <button onClick={() => setShowForm(!showForm)} className="bg-neutral-800 hover:bg-neutral-700 text-white px-6 py-3 rounded border border-neutral-700 font-medium transition-colors flex items-center gap-2" data-id="element-230" data-mp="11g22dqxgz0ts">
              <MessageSquare className="w-4 h-4" data-id="element-231" data-mp="16ag3m9ytc26d" />
              Dejar mi reseña
            </button>}

          {showForm && <div className="bg-neutral-800 p-6 rounded border border-neutral-700 max-w-xl w-full" data-id="element-232" data-mp="1k6jsroutxkbz">
              <h4 className="font-bold text-lg mb-4 text-center text-yellow-500" data-id="element-233" data-mp="1g5ht56x0369h">
                Tu opinión nos importa
              </h4>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-234" data-mp="3eocsdnx10e0z">
                <input type="text" placeholder="Tu nombre" className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none" value={newReview.name} onChange={e => setNewReview({
              ...newReview,
              name: e.target.value
            })} data-id="element-235" data-mp="3jfutcbz1uely" />
                <textarea placeholder="Tu experiencia con los planos..." rows={3} className="w-full p-3 rounded bg-neutral-900 border border-neutral-700 text-white focus:border-yellow-500 outline-none resize-none" value={newReview.text} onChange={e => setNewReview({
              ...newReview,
              text: e.target.value
            })} data-id="element-236" data-mp="30rpwlogt7twn" />
                <div className="flex items-center gap-3" data-id="element-237" data-mp="1vq6tkjofbo41">
                  <span className="text-sm text-neutral-400" data-id="element-238" data-mp="1volymsy7635n">
                    Calificación:
                  </span>
                  <div className="flex gap-1" data-id="element-239" data-mp="1qpj2xz43x9ac">
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setNewReview({
                  ...newReview,
                  rating: star
                })} className="p-1" data-id="element-240" data-mp="1lpwh51a7qkpx">
                        <Star className={`w-6 h-6 ${(hoverRating ? star <= hoverRating : star <= newReview.rating) ? 'text-yellow-500 fill-yellow-500' : 'text-neutral-600'}`} data-id="element-241" data-mp="3lbdv8k55wea3" />
                      </button>)}
                  </div>
                </div>
                <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 rounded transition-colors" data-id="element-242" data-mp="3h8qx61hwdx4g">
                  Enviar reseña
                </button>
              </form>
            </div>}
        </div>
      </div>
    </section>;
};
const FabricarSection = () => <section className="space-y-8" data-id="element-243" data-mp="3udxfu0cxnyq">
    <div className="text-center space-y-2" data-id="element-244" data-mp="3tck1ivvcpdu">
      <ScrollReveal data-id="element-245" data-mp="3wgwt4negtg4">
        <h3 className="text-3xl font-black text-white uppercase" data-id="element-246" data-mp="2jm1tzobgleh0">
          Mirá todo lo que vas a poder{' '}
          <span className="text-yellow-500" data-id="element-247" data-mp="2ol4y96jm7gnx">FABRICAR</span>
        </h3>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-248" data-mp="2h0ub312pkhdg">
        <p className="text-neutral-400 font-medium" data-id="element-249" data-mp="2h00z9low71og">
          Cada diseño está probado por herreros reales en Argentina
        </p>
      </ScrollReveal>
    </div>
    <div className="grid md:grid-cols-3 gap-6" data-id="element-250" data-mp="2q1s9n3udnwon">
      <ScrollReveal delay={2} data-id="element-251" data-mp="2q1ihb9lv1dfs">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-252" data-mp="2l2xovwcuny1w">
          <div className="flex items-center gap-3 mb-4" data-id="element-253" data-mp="1xcl9k0f9yz1a">
            <Hammer className="text-yellow-500 w-5 h-5" data-id="element-254" data-mp="1xb0e88l4zc2d" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-255" data-mp="1td2o93jjklxx">
              Muebles de Acero y Madera
            </h4>
          </div>
          <ul className="space-y-3 mb-6 flex-1" data-id="element-256" data-mp="275956ruiqwyf">
            {['Alta demanda real', 'Se venden todo el año', 'Precios 3-4x más altos'].map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-neutral-400" data-id="element-257" data-mp="19ns9brrme50v" data-mpi={j}>
                <Check className="w-4 h-4 text-yellow-500 mt-0.5 shrink-0" data-id="element-258" data-mp="p2qkfex7pv3u" />
                {item}
              </li>)}
          </ul>
          <div className="mt-auto flex justify-center" data-id="element-259" data-mp="t5mvmkkfaoxr">
            <div className="flex items-center gap-2 bg-red-600 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-red shadow-lg" data-id="element-260" data-mp="y1lnwj8vgr3g">
              <Star className="w-3.5 h-3.5 text-white fill-white" data-id="element-261" data-mp="1331boj2fpbpj" />
              <span className="text-xs font-bold uppercase text-white" data-id="element-262" data-mp="17zrrr6e8o7ay">
                EL MÁS PEDIDO
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={3} data-id="element-263" data-mp="1gsuzqz647ry7">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-264" data-mp="1gto6w18zkjgv">
          <div className="flex items-center gap-3 mb-4" data-id="element-265" data-mp="1lu2an73k1793">
            <Wrench className="text-yellow-500 w-5 h-5" data-id="element-266" data-mp="1qslxratvwp31" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-267" data-mp="1vq5i8sh6dy3f">
              Portones, Escaleras y Trailers
            </h4>
          </div>
          <p className="text-sm text-neutral-400 mb-6 flex-1 leading-relaxed" data-id="element-268" data-mp="3g97pzbxuollw">
            Proyectos de mayor escala y clientes recurrentes. Estructuras
            sólidas y funcionales que aseguran un flujo de caja constante y
            márgenes altos.
          </p>
          <div className="mt-auto flex justify-center" data-id="element-269" data-mp="31byrzze1kjl7">
            <div className="flex items-center gap-2 bg-yellow-400 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-yellow shadow-lg" data-id="element-270" data-mp="31d9s9p8a397k">
              <TrendingUp className="w-3.5 h-3.5 text-black" data-id="element-271" data-mp="3tzb6dma1tl3f" />
              <span className="text-xs font-bold uppercase text-black" data-id="element-272" data-mp="3u271l2uihvo6">
                ALTA RENTABILIDAD
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={4} data-id="element-273" data-mp="3k7ymphyem18h">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-274" data-mp="lkko60fddecb">
          <div className="flex items-center gap-3 mb-4" data-id="element-275" data-mp="gsj3pr81shb7">
            <Layout className="text-yellow-500 w-5 h-5" data-id="element-276" data-mp="27e53tyto3ld2" />
            <h4 className="text-lg font-bold text-yellow-500" data-id="element-277" data-mp="27fpz5qnt38bz">
              Máquinas de Gym Profesionales
            </h4>
          </div>
          <p className="text-sm text-neutral-400 mb-6 flex-1 leading-relaxed" data-id="element-278" data-mp="1ydgpf30d3izn">
            El nicho más rentable y técnico de la actualidad. Equipamiento
            fitness con mecánica probada para un mercado exclusivo que busca
            calidad industrial.
          </p>
          <div className="mt-auto flex justify-center" data-id="element-279" data-mp="2q6qwka9a2vtf">
            <div className="flex items-center gap-2 bg-green-600 rounded-lg py-2 px-4 w-fit mx-auto animate-glow-pulse-green shadow-lg" data-id="element-280" data-mp="2m443y74s96v6">
              <DollarSign className="w-3.5 h-3.5 text-white" data-id="element-281" data-mp="2ha88bbbzrw36" />
              <span className="text-xs font-bold uppercase text-white" data-id="element-282" data-mp="2cc6scz9v4cvx">
                MÁXIMA RENTABILIDAD
              </span>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>;
const EbookPreviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const nextSlide = useCallback(() => setCurrentIndex(prev => (prev + 1) % EBOOK_PREVIEW_IMAGES.length), []);
  const prevSlide = useCallback(() => setCurrentIndex(prev => (prev - 1 + EBOOK_PREVIEW_IMAGES.length) % EBOOK_PREVIEW_IMAGES.length), []);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);
  return <section className="space-y-8" data-id="element-283" data-mp="8wuyr6c1nuiw">
      <div className="text-center space-y-2" data-id="element-284" data-mp="dvg0xbauwo9z">
        <ScrollReveal data-id="element-285" data-mp="du4lufbynu3k">
          <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-286" data-mp="dumpvy4v7cm1">
            Así se ve por dentro el ebook
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-287" data-mp="mvkyktq908ay">
          <p className="text-neutral-400 text-sm md:text-base" data-id="element-288" data-mp="mwnn4v03lynp">
            Ejemplos reales de páginas, planos y guías incluidas en Maestro de
            Muebles Industriales
          </p>
        </ScrollReveal>
      </div>
      <div className="relative overflow-hidden rounded-xl bg-neutral-900 border border-neutral-800 max-w-md mx-auto shadow-2xl" onTouchStart={e => {
      touchStartX.current = e.touches[0].clientX;
      setIsPaused(true);
    }} onTouchMove={e => {
      touchEndX.current = e.touches[0].clientX;
    }} onTouchEnd={() => {
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > 50) {
        diff > 0 ? nextSlide() : prevSlide();
      }
      setTimeout(() => setIsPaused(false), 5000);
    }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-289" data-mp="2evkni6ta2mwc">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentIndex * 100}%)`
      }} data-id="element-290" data-mp="1hbq9fygssd8n">
          {EBOOK_PREVIEW_IMAGES.map((img, idx) => <div key={idx} className="w-full flex-shrink-0" data-id="element-291" data-mp="3sxig4n5nuty9" data-mpi={idx}>
              <img src={img} alt={`Página del ebook ${idx + 1}`} className="w-full aspect-[9/16] object-contain bg-white" data-id="element-292" data-mp="3f5u2gffrjxf6" />
            </div>)}
        </div>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-293" data-mp="357elh5aga4je">
          {EBOOK_PREVIEW_IMAGES.map((_, idx) => <button key={idx} onClick={() => {
          setCurrentIndex(idx);
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), 5000);
        }} className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-yellow-500' : 'bg-neutral-600'}`} data-id="element-294" data-mp="3a8c1pcbwgoi9" data-mpi={idx} />)}
        </div>
      </div>
      <p className="text-center text-neutral-400 text-sm" data-id="element-295" data-mp="ygombafa7naq">
        <span className="text-yellow-500 font-medium" data-id="element-296" data-mp="9r3pujxww1an">Planos claros</span>,{' '}
        <span className="text-yellow-500 font-medium" data-id="element-297" data-mp="4rhd0blzwn2d">medidas exactas</span> y{' '}
        <span className="text-yellow-500 font-medium" data-id="element-298" data-mp="4pmtn1qdh30e">criterio industrial</span>{' '}
        aplicado a cada proyecto.
      </p>
    </section>;
};
const TrustSection = () => <section className="bg-[#1a1a1a] border border-yellow-500/20 rounded-xl p-8 md:p-10" data-id="element-299" data-mp="3qy601w3cs3ju">
    <div className="text-center mb-8" data-id="element-300" data-mp="3mxvp050pemy4">
      <ScrollReveal data-id="element-301" data-mp="3myx18ctghfhf">
        <h3 className="text-xl md:text-2xl font-black text-white flex items-center justify-center gap-2" data-id="element-302" data-mp="3i5u8g6wi6a2a">
          <Lock className="w-5 h-5 text-yellow-500" data-id="element-303" data-mp="3d6hlzn9jn508" />
          Compra segura y acceso inmediato
        </h3>
      </ScrollReveal>
      <ScrollReveal delay={1} data-id="element-304" data-mp="389r7339h6fge">
        <p className="text-neutral-400 text-sm mt-2" data-id="element-305" data-mp="386d2dodc9u5s">
          Este material fue creado para que trabajes con tranquilidad, claridad
          y respaldo desde el primer día.
        </p>
      </ScrollReveal>
    </div>
    <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-306" data-mp="1epqxo85u3wii">
      {[{
      icon: Zap,
      color: 'text-green-500',
      title: 'Acceso inmediato',
      desc: 'Recibís el material completo apenas se confirma el pago.'
    }, {
      icon: Download,
      color: 'text-green-500',
      title: 'Descarga segura y privada',
      desc: 'Tus archivos están protegidos y disponibles para siempre.'
    }, {
      icon: ShieldCheck,
      color: 'text-yellow-500',
      title: 'Garantía de satisfacción 7 días',
      desc: 'Si no es lo que esperabas, podés solicitar la devolución.'
    }, {
      icon: BookOpen,
      color: 'text-yellow-500',
      title: 'Producto digital profesional',
      desc: 'Planos claros, medidas exactas y criterio industrial real.'
    }].map((item, i) => <ScrollReveal key={i} delay={2 + i} data-id="element-307" data-mp="h9be1fvotx49" data-mpi={i}>
          <div className="flex items-start gap-3 p-4 bg-neutral-900/50 rounded-lg" data-id="element-308" data-mp="h809hduf4lc3">
            <item.icon className={`w-5 h-5 ${item.color} shrink-0 mt-0.5`} data-id="element-309" data-mp="97kjz563aos8" />
            <div data-id="element-310" data-mp="56qsy2xcotv4">
              <p className="text-white font-bold text-sm" data-id="element-311" data-mp="57ac1myqloaq">{item.title}</p>
              <p className="text-neutral-400 text-xs" data-id="element-312" data-mp="iy5eageqd75c">{item.desc}</p>
            </div>
          </div>
        </ScrollReveal>)}
    </div>
    <ScrollReveal delay={6} data-id="element-313" data-mp="e26vr9g32jcu">
      <p className="text-center text-neutral-500 text-sm mt-6" data-id="element-314" data-mp="3mfnlclmoia4p">
        Más de 3.200 herreros y fabricantes ya trabajan con este sistema.
      </p>
    </ScrollReveal>
  </section>;
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="space-y-8" data-id="element-315" data-mp="3rf08l7hgpj7t">
      <div className="text-center space-y-2" data-id="element-316" data-mp="3reqpm3uu4cbm">
        <ScrollReveal data-id="element-317" data-mp="3rh39imk5kwrb">
          <h3 className="text-2xl md:text-3xl font-black text-white" data-id="element-318" data-mp="1bnm3l57207xc">
            Resolvé acá tus dudas antes de comprar
          </h3>
        </ScrollReveal>
        <ScrollReveal delay={1} data-id="element-319" data-mp="16oj9ugwixo4o">
          <p className="text-neutral-400" data-id="element-320" data-mp="2ome8rtkr6h58">
            Todo lo que necesitás saber sobre el acceso y el contenido
          </p>
        </ScrollReveal>
      </div>
      <div className="max-w-2xl mx-auto space-y-3" data-id="element-321" data-mp="2tn26ey3hlw8f">
        {FAQ_DATA.map((faq, i) => <ScrollReveal key={i} delay={2 + i} data-id="element-322" data-mp="2fnao4l5xttom" data-mpi={i}>
            <div className="bg-[#1a1a1a] border border-neutral-700/50 rounded-lg overflow-hidden" data-id="element-323" data-mp="2kkswa9c4s4vk">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full p-5 flex items-center justify-between text-left" data-id="element-324" data-mp="38anbgxjxa5iz">
                <div className="flex items-center gap-3" data-id="element-325" data-mp="2ykllu1bx8f1y">
                  <HelpCircle className="w-5 h-5 text-yellow-500 shrink-0" data-id="element-326" data-mp="2yk2dncc2p514" />
                  <span className="text-white font-medium" data-id="element-327" data-mp="33in6gqozwmfj">{faq.q}</span>
                </div>
                <ChevronDown className={`w-5 h-5 text-neutral-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-328" data-mp="3r8zoiudyfzju" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-40' : 'max-h-0'}`} data-id="element-329" data-mp="1vy8epsl7xtkt">
                <p className="px-5 pb-5 text-neutral-400 text-sm pl-13" data-id="element-330" data-mp="1r4x2td1jumm1">
                  {faq.a}
                </p>
              </div>
            </div>
          </ScrollReveal>)}
      </div>
    </section>;
};
const CSS_STYLES = `
/* === HERO ENTRANCE === */
@keyframes hero-zoom { 0% { opacity: 0; transform: scale(1.03); } 100% { opacity: 1; transform: scale(1); } }
.animate-hero-zoom { animation: hero-zoom 0.9s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

@keyframes float-up-entry { 0% { opacity: 0; transform: translateY(40px); } 100% { opacity: 1; transform: translateY(0); } }
.animate-float-up-entry { animation: float-up-entry 0.9s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }

@keyframes hero-kit-enter {
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
}
.animate-hero-kit-enter { animation: hero-kit-enter 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.9s both; }

@keyframes hero-kit-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
.animate-hero-kit-float { animation: hero-kit-float 4s ease-in-out 1.5s infinite; }

@keyframes hero-title-reveal {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-hero-stars { animation: hero-title-reveal 0.4s cubic-bezier(0.22, 1, 0.36, 1) both; }
.animate-hero-title-red { animation: hero-title-reveal 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.4s both; }
.animate-hero-title-white { animation: hero-title-reveal 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.6s both; }

@keyframes hero-offer-reveal {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}
.animate-hero-offer { animation: hero-offer-reveal 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both; }

@keyframes purchase-cta-shine {
  0%, 80% { transform: translateX(-160%) skewX(-18deg); opacity: 0; }
  82% { opacity: 0.45; }
  100% { transform: translateX(280%) skewX(-18deg); opacity: 0; }
}
@keyframes purchase-cta-shadow {
  0%, 80%, 100% { box-shadow: 0 4px 18px rgba(250, 204, 21, 0.2); }
  88% { box-shadow: 0 7px 26px rgba(250, 204, 21, 0.32); }
}
.purchase-cta {
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(250, 204, 21, 0.2);
  animation: purchase-cta-shadow 4s ease-in-out infinite;
}
.purchase-cta::after {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 32%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.48), transparent);
  animation: purchase-cta-shine 4s ease-in-out infinite;
  pointer-events: none;
}
@media (hover: hover) and (pointer: fine) {
  .purchase-cta:hover { transform: translateY(-2px); box-shadow: 0 7px 24px rgba(250, 204, 21, 0.3); }
}

@keyframes fade-up { 0% { opacity: 0; transform: translateY(12px); } 100% { opacity: 1; transform: translateY(0); } }
.animate-fade-up { animation: fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards; opacity: 0; }

@keyframes pop-scale { 0% { opacity: 0; transform: scale(0.98); } 60% { transform: scale(1.02); } 100% { opacity: 1; transform: scale(1); } }
.animate-pop-scale { animation: pop-scale 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; }

/* === TYPE REVEAL === */
@keyframes type-reveal { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
.char-reveal { display: inline-block; opacity: 0; animation: type-reveal 0.04s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

/* === LEGACY SCROLL ANIMATIONS (FearToSystemCard compat) === */
@keyframes fade-in-down { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
.animate-fade-in-down { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
.animate-fade-in-down-delay-1 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.12s forwards; opacity: 0; }
.animate-fade-in-down-delay-2 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.24s forwards; opacity: 0; }
.animate-fade-in-down-delay-3 { animation: fade-in-down 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.36s forwards; opacity: 0; }

/* === DOT PULSE (LIVE INDICATOR) === */
@keyframes dot-pulse-green {
  0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
  50% { transform: scale(1.25); opacity: 0.55; box-shadow: 0 0 8px 3px rgba(34, 197, 94, 0.25); }
}
.animate-dot-pulse-green { animation: dot-pulse-green 1.2s ease-in-out infinite; }

@keyframes dot-pulse-red {
  0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
  50% { transform: scale(1.25); opacity: 0.55; box-shadow: 0 0 8px 3px rgba(239, 68, 68, 0.25); }
}
.animate-dot-pulse-red { animation: dot-pulse-red 1.2s ease-in-out infinite; }

/* === BUTTON SHINE === */
@keyframes shine-global { 0% { left: -100%; } 15% { left: 100%; } 100% { left: 100%; } }
.animate-shine { position: relative; overflow: hidden; }
.animate-shine::after { content: ''; position: absolute; top: 0; left: -100%; width: 50%; height: 100%; background: linear-gradient(to right, transparent, rgba(255,255,255,0.5), transparent); transform: skewX(-20deg); animation: shine-global 3s infinite; pointer-events: none; z-index: 1; }

.animate-shine-sweep { position: relative; overflow: hidden; }
.animate-shine-sweep::after { content: ''; position: absolute; top: 0; left: -100%; width: 50%; height: 100%; background: linear-gradient(to right, transparent, rgba(255,255,255,0.5), transparent); transform: skewX(-20deg); animation: shine-global 3s infinite; pointer-events: none; z-index: 1; }

/* === CARD GLOW === */
@keyframes glow-pulse { 0%, 100% { box-shadow: 0 0 20px rgba(234, 179, 8, 0.3); } 50% { box-shadow: 0 0 30px rgba(234, 179, 8, 0.5); } }
.animate-glow-pulse { animation: glow-pulse 3s infinite; }

@keyframes neon-yellow-glow { 0%, 100% { box-shadow: 0 0 15px rgba(250, 204, 21, 0.3), 0 0 30px rgba(250, 204, 21, 0.15); } 50% { box-shadow: 0 0 25px rgba(250, 204, 21, 0.5), 0 0 50px rgba(250, 204, 21, 0.25); } }
.animate-neon-yellow { animation: neon-yellow-glow 2.5s ease-in-out infinite; }

/* === BONUS CARD EFFECTS === */
@keyframes red-glow { 0%, 100% { box-shadow: 0 0 20px rgba(239, 68, 68, 0.2); } 50% { box-shadow: 0 0 30px rgba(239, 68, 68, 0.35); } }
.animate-red-glow { animation: red-glow 3s ease-in-out infinite; }

@keyframes premium-badge-pulse { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.9; transform: scale(1.03); } }
.animate-premium-badge-pulse { animation: premium-badge-pulse 2.5s ease-in-out infinite; }

/* === FABRICAR SECTION BADGES === */
@keyframes glow-pulse-red { 0%, 100% { box-shadow: 0 0 10px rgba(220, 38, 38, 0.5); } 50% { box-shadow: 0 0 20px rgba(220, 38, 38, 0.8); } }
.animate-glow-pulse-red { animation: glow-pulse-red 2s infinite; }

@keyframes glow-pulse-yellow { 0%, 100% { box-shadow: 0 0 10px rgba(250, 204, 21, 0.5); } 50% { box-shadow: 0 0 20px rgba(250, 204, 21, 0.8); } }
.animate-glow-pulse-yellow { animation: glow-pulse-yellow 2s infinite; }

@keyframes glow-pulse-green { 0%, 100% { box-shadow: 0 0 10px rgba(22, 163, 74, 0.5); } 50% { box-shadow: 0 0 20px rgba(22, 163, 74, 0.8); } }
.animate-glow-pulse-green { animation: glow-pulse-green 2s infinite; }

/* === MISC === */
@keyframes arrow-vibrate { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(3px); } 75% { transform: translateX(-3px); } }
.animate-arrow-vibrate { animation: arrow-vibrate 1s ease-in-out infinite; }

/* === NUMBER GLOW === */
@keyframes number-glow {
  0%, 100% { text-shadow: 0 0 10px rgba(253, 224, 71, 0.3), 0 0 20px rgba(253, 224, 71, 0.1); }
  50% { text-shadow: 0 0 20px rgba(253, 224, 71, 0.6), 0 0 40px rgba(253, 224, 71, 0.3); }
}
.animate-number-glow { animation: number-glow 2.5s ease-in-out infinite; }

/* === NEON TEXT GLOW (constant bright) === */
@keyframes neon-text-glow {
  0%, 100% { text-shadow: 0 0 8px rgba(250, 204, 21, 0.6), 0 0 20px rgba(250, 204, 21, 0.4), 0 0 40px rgba(250, 204, 21, 0.2); }
  50% { text-shadow: 0 0 12px rgba(250, 204, 21, 0.8), 0 0 30px rgba(250, 204, 21, 0.6), 0 0 60px rgba(250, 204, 21, 0.3); }
}
.animate-neon-text-glow { animation: neon-text-glow 1.8s ease-in-out infinite; }

/* === LED BLINK (fast pulse for indicators) === */
@keyframes led-blink {
  0%, 100% { opacity: 1; transform: scale(1); box-shadow: 0 0 4px currentColor; }
  50% { opacity: 0.4; transform: scale(0.85); box-shadow: 0 0 8px currentColor; }
}
.animate-led-blink { animation: led-blink 0.8s ease-in-out infinite; }

/* === FIRE GRADIENT (premium bonus background) === */
@keyframes fire-gradient {
  0% { background: linear-gradient(135deg, rgba(127,29,29,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(153,27,27,0.2) 100%); }
  33% { background: linear-gradient(135deg, rgba(153,27,27,0.2) 0%, rgba(127,29,29,0.3) 50%, rgba(0,0,0,0.1) 100%); }
  66% { background: linear-gradient(135deg, rgba(0,0,0,0.1) 0%, rgba(153,27,27,0.2) 50%, rgba(127,29,29,0.3) 100%); }
  100% { background: linear-gradient(135deg, rgba(127,29,29,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(153,27,27,0.2) 100%); }
}
.animate-fire-gradient { animation: fire-gradient 4s ease-in-out infinite; }

/* === BORDER BLINK RED (premium card border) === */
@keyframes border-blink-red {
  0%, 100% { border-color: rgba(239, 68, 68, 1); box-shadow: 0 0 15px rgba(239, 68, 68, 0.3); }
  50% { border-color: rgba(239, 68, 68, 0.3); box-shadow: 0 0 5px rgba(239, 68, 68, 0.1); }
}
.animate-border-blink-red { animation: border-blink-red 1.5s ease-in-out infinite; }

/* === CHECK BOUNCE (animated check icon) === */
@keyframes check-bounce {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.3); }
}
.animate-check-bounce { animation: check-bounce 2s ease-in-out infinite; }

/* === CTA PULSE (subtle shake every 3s) === */
@keyframes cta-pulse {
  0%, 88%, 100% { transform: scale(1) translateX(0); }
  90% { transform: scale(1.02) translateX(-2px); }
  92% { transform: scale(1.02) translateX(2px); }
  94% { transform: scale(1.01) translateX(-1px); }
  96% { transform: scale(1.01) translateX(1px); }
  98% { transform: scale(1) translateX(0); }
}
.animate-cta-pulse { animation: cta-pulse 3s ease-in-out infinite; }

/* === INCLUIDO HOY GLOW === */
@keyframes incluido-glow {
  0%, 100% { box-shadow: 0 0 8px rgba(239, 68, 68, 0.3), 0 0 16px rgba(239, 68, 68, 0.15); }
  50% { box-shadow: 0 0 14px rgba(239, 68, 68, 0.5), 0 0 28px rgba(239, 68, 68, 0.25); }
}
.animate-incluido-glow { animation: incluido-glow 2s ease-in-out infinite; }

/* === STICKY HEADER BUTTON SHAKE === */
@keyframes header-btn-shake {
  0%, 85%, 100% { transform: translateX(0); }
  87% { transform: translateX(-2px) rotate(-1deg); }
  89% { transform: translateX(2px) rotate(1deg); }
  91% { transform: translateX(-2px) rotate(-0.5deg); }
  93% { transform: translateX(2px) rotate(0.5deg); }
  95% { transform: translateX(0); }
}
.animate-header-shake { animation: header-btn-shake 5s ease-in-out infinite; }

/* === REDUCED MOTION === */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; }
}
`;
const TypeReveal = ({
  text,
  className = '',
  delay = 0
}: {
  text: string;
  className?: string;
  delay?: number;
}) => {
  return <span className={className} data-id="element-331" data-mp="2y4w1dbe3ns4b">
      {text.split('').map((char, i) => <span key={i} className="char-reveal" style={{
      animationDelay: `${delay + i * 0.03}s`
    }} data-id="element-332" data-mp="2u4c50a1cosj8" data-mpi={i}>
          {char}
        </span>)}
    </span>;
};
export function App() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-200 font-sans selection:bg-yellow-500/30 selection:text-yellow-200" data-id="element-333" data-mp="nckqvzm1p4nk">
      <style data-id="element-334" data-mp="ie9htr3kqy6e">{CSS_STYLES}</style>
      <MetaPixel data-id="element-335" data-mp="id86rmmk6boo" />
      <SocialProofPopup data-id="element-336" data-mp="ifudjk1mkn5u" />
      <StickyHeader data-id="element-337" data-mp="11q3fgl4g52ni" />

      <header className="relative isolate overflow-hidden bg-[#101010] px-3 py-6 md:px-8 md:py-10" data-id="element-338" data-mp="11pbstzstuf9d">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/af4da110-45e3-4583-b4bb-e482aa5ee255.jpg" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 -z-20 h-full w-full object-cover opacity-45 blur-[1.5px]" data-id="element-339" data-mp="wq8n0d50w50c" />
        <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-black/80 via-black/75 to-[#101010]/95" data-id="element-340" data-mp="j0x2leqc359m" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-red-600/40" data-id="element-341" data-mp="e2lqsyghakor" />

        <div className="relative mx-auto grid max-w-6xl items-center gap-2 md:grid-cols-2 md:gap-7" data-id="element-342" data-mp="sr84ywudd6ee">
          <div className="order-1 text-center md:text-left" data-id="element-343" data-mp="nxnh3xmhpssx">
            <div className="flex items-center justify-center gap-1 animate-hero-stars md:justify-start" aria-label="Valoración 4,9 de 5" data-id="element-344" data-mp="8kqw1dsirmt">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" data-id="element-345" data-mp="26x4ln783m0jm" />)}
              <span className="ml-1 text-xs font-bold text-neutral-200" data-id="element-346" data-mp="2bomm7u67lz42">4,9/5</span>
            </div>
            <p className="mt-2 animate-fade-up text-[10px] font-bold uppercase tracking-[0.17em] text-neutral-300 sm:text-xs md:text-sm" style={{
            animationDelay: '0.18s'
          }} data-id="element-347" data-mp="1x08aetqtf0bd">
              PARA HERREROS Y EMPRENDEDORES
            </p>
            <h1 className="mt-3 font-black uppercase leading-[0.86] tracking-[-0.055em]" data-id="element-348" data-mp="2ponmb7enh2ih">
              <span className="block text-[clamp(1.65rem,7vw,3.4rem)] text-red-500 animate-hero-title-red" data-id="element-349" data-mp="2ulw436vvz4j7">
                SI YA SABÉS SOLDAR,
              </span>
              <span className="mt-2 block text-[clamp(2.15rem,9.5vw,4.75rem)] text-white animate-hero-title-white" data-id="element-350" data-mp="2koi0w8yz4c8u">
                HOY PODÉS EMPEZAR
              </span>
              <span className="mt-1 block text-[clamp(2.15rem,9.5vw,4.75rem)] text-white animate-hero-title-white" data-id="element-351" data-mp="15anb2ko05hse">
                A FABRICAR PARA VENDER.
              </span>
            </h1>
            <div className="mx-auto mt-3 h-1 w-16 -skew-x-[28deg] bg-red-500 md:mx-0" data-id="element-352" data-mp="3bydx4jzsjr4f" />
            <div className="mt-3" data-id="element-353" data-mp="36zjg9nldwcmy">
              <p className="animate-hero-offer text-base font-black uppercase tracking-wide text-yellow-400 md:text-lg" data-id="element-354" data-mp="326gl5b0ykv4n">
                2 LIBROS AL PRECIO DE 1
              </p>
              <p className="mx-auto mt-1 max-w-xl animate-fade-up text-[15px] leading-relaxed text-white md:mx-0 md:text-lg" style={{
              animationDelay: '0.85s'
            }} data-id="element-355" data-mp="2x5ss6jt6647s">
                Más de 1.100 planos de muebles industriales y máquinas de gimnasio.
              </p>
            </div>
          </div>

          <div className="order-2 relative mx-auto w-full max-w-2xl animate-hero-kit-enter md:-mr-3" data-id="element-356" data-mp="2j9p3f612eo2p">
            <div className="pointer-events-none absolute inset-x-[12%] bottom-[8%] h-1/3 rounded-full bg-gradient-to-t from-amber-400/15 to-transparent blur-3xl" data-id="element-357" data-mp="2eb5dkujcos52" />
            <div className="relative animate-hero-kit-float" data-id="element-358" data-mp="chxpowpo927k">
              <img src="https://cdn.magicpatterns.com/uploads/5PqDCj9vkaKEHyoLHV7d91/ChatGPT_Image_25_sept_2026,_20_19_20.webp" alt="Pack Maestro de Muebles Industriales y Máquinas de Gimnasio Rentables con planos" fetchPriority="high" className="block h-auto w-full" data-id="element-359" data-mp="kyybdvzzm5s6" />
            </div>
          </div>

          <div className="order-3 md:col-span-2 animate-fade-up" style={{
          animationDelay: '1.15s'
        }} data-id="element-360" data-mp="1zu7f1naz27d">
            <ScrollToBuy className="block w-full md:mx-auto md:max-w-xl" data-id="element-361" data-mp="627f3vlm1a6s">
              <button className="purchase-cta w-full rounded-lg bg-yellow-400 px-6 py-5 text-lg font-black uppercase tracking-wide text-black transition-[background-color,box-shadow,transform] duration-200 hover:bg-yellow-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-yellow-400" data-id="element-362" data-mp="azpmvinw5jd7">
                <span className="relative z-10" data-id="element-363" data-mp="1rcxpnedhr382">QUIERO LOS PLANOS AHORA →</span>
              </button>
            </ScrollToBuy>
            <p className="mt-2 flex items-center justify-center gap-1.5 text-center text-[11px] font-bold uppercase tracking-wide text-yellow-300/90" data-id="element-364" data-mp="30da9e3arcc4n">
              <Zap className="h-3.5 w-3.5" aria-hidden="true" data-id="element-365" data-mp="39d6phgj302o3" />
              Descargá tus planos hoy y empezá tu próximo proyecto.
            </p>
            <p className="mt-2 text-center text-xs font-medium text-neutral-300 md:text-sm" data-id="element-366" data-mp="34fdlmu593kqz">
              Descarga inmediata <span className="px-1.5" data-id="element-367" data-mp="3eb8d8ergcq5w">·</span> Pago único{' '}
              <span className="px-1.5" data-id="element-368" data-mp="3eayjcg3adyux">·</span> Acceso de por vida
            </p>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-8 space-y-14 pb-16" data-id="element-369" data-mp="3s4g1pxk8l5jd">
        <WorkshopRealitySection data-id="element-370" data-mp="3o1thahpwamw7" />
        <section className="bg-neutral-900 rounded-xl p-8 md:p-12 border border-neutral-800 shadow-2xl relative overflow-hidden" data-id="element-371" data-mp="5vev5vhh36mq">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-600/10 blur-[80px] rounded-full -z-10" data-id="element-372" data-mp="x3m3mz0505k" />
          <div className="text-center space-y-6 mb-12" data-id="element-373" data-mp="kjf6mkfbpxvb">
            <ScrollReveal data-id="element-374" data-mp="ph70hjzj3u25">
              <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight leading-none" data-id="element-375" data-mp="phgq36gnvz7b">
                Maestro de <br data-id="element-376" data-mp="ajeiml6ietks" />
                <span className="text-yellow-500" data-id="element-377" data-mp="am0p0hhnz31f">Muebles Industriales</span>
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={1} data-id="element-378" data-mp="1rmees82wgon">
              <p className="text-xl text-neutral-300 font-medium" data-id="element-379" data-mp="1qkz2bk15814">
                Es un ebook práctico creado para una sola cosa:
              </p>
            </ScrollReveal>
            <ScrollReveal delay={2} data-id="element-380" data-mp="3nzchywp81bv8">
              <p className="text-2xl font-black text-white uppercase" data-id="element-381" data-mp="3o0duz6pss8fl">
                Que dejes de improvisar y empieces a fabricar con confianza.
              </p>
            </ScrollReveal>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-382" data-mp="3eyo17u8g0xen">
            <ScrollReveal type="fade-left" data-id="element-383" data-mp="3iyoirnqu9opx">
              <div className="space-y-6" data-id="element-384" data-mp="3j1kfj8qya7cs">
                <div className="rounded-lg overflow-hidden shadow-2xl border border-neutral-800 bg-black" data-id="element-385" data-mp="1phadeiavr35i">
                  <video src="https://cdn.magicpatterns.com/uploads/hGMRq4tpMpnBX8eU3bEx8h/mobile_web.undefined" autoPlay muted loop playsInline className="w-full h-auto block opacity-90" data-id="element-386" data-mp="1kp96lbwhe4mv" />
                </div>
              </div>
            </ScrollReveal>
            <div className="space-y-4" data-id="element-387" data-mp="23gie5fmoyjbt">
              <ScrollReveal delay={1} data-id="element-388" data-mp="23ep8o3nte55e">
                <p className="text-neutral-300" data-id="element-389" data-mp="1yh5v75yxxwei">
                  No es un PDF de inspiración. No es motivación vacía. No es
                  teoría.
                </p>
              </ScrollReveal>
              <ScrollReveal delay={2} data-id="element-390" data-mp="n31rh82jwtw9">
                <p className="text-white font-bold text-lg uppercase" data-id="element-391" data-mp="n43fed4o1ave">
                  Es ejecución real.
                </p>
              </ScrollReveal>
              <ScrollReveal delay={3} data-id="element-392" data-mp="2uotsp1mam9qy">
                <p className="text-neutral-300" data-id="element-393" data-mp="2upv4x9f1p2a9">Un sistema para que puedas:</p>
              </ScrollReveal>
              <ul className="space-y-3" data-id="element-394" data-mp="2yqf3mhf9odyi">
                {['Empezar un mueble sabiendo exactamente qué hacer', 'Ahorrar tiempo de diseño y prueba/error', 'Evitar errores caros de material y estructura', 'Repetir modelos vendibles (rentables)', 'Cotizar rápido y cobrar con seguridad'].map((item, i) => <ScrollReveal key={i} delay={4 + i} data-id="element-395" data-mp="3ifz6zccl4tz5" data-mpi={i}>
                    <li className="flex items-start gap-3" data-id="element-396" data-mp="3mgj3qet8xvkr">
                      <Check className="text-yellow-500 w-6 h-6 shrink-0" data-id="element-397" data-mp="3rekkgt379it2" />
                      <span className="text-neutral-200 font-medium" data-id="element-398" data-mp="3rcgk2l4if1xj">
                        {item}
                      </span>
                    </li>
                  </ScrollReveal>)}
              </ul>
            </div>
          </div>
          <CTAButton text="QUIERO LOS PLANOS AHORA" data-id="element-399" data-mp="2rwbo5nqygcp" />
        </section>
        <ProjectsCarousel data-id="element-400" data-mp="3uwgsopjk62hj" />
        <FabricarSection data-id="element-401" data-mp="3ux9wpir4udvz" />
        <BonusesSection data-id="element-402" data-mp="3uvyu3m9fbc6g" />
        <div data-id="element-403" data-mp="3uunrvqvmmchg">
          <ReviewsSection data-id="element-404" data-mp="cihgiau0kh42" />
          <div className="space-y-8" data-id="element-405" data-mp="cir27m81023y">
            <CompactAccessSection data-id="element-406" data-mp="chpqdfj6rbl6" />
            <ScrollReveal type="zoom" data-id="element-407" data-mp="7jo64ra0x684">
              <DynamicPurchaseCard data-id="element-408" data-mp="7kpg0sfazmo9" />
            </ScrollReveal>
          </div>
        </div>
        <EbookPreviewSection data-id="element-409" data-mp="3g0999rfz553b" />
        <TrustSection data-id="element-410" data-mp="3g1ahzp9ipfhv" />
        <FAQSection data-id="element-411" data-mp="3bxmbl9wmgpy7" />
      </main>

      <footer className="bg-black border-t border-neutral-900 py-12 text-center text-neutral-600 text-sm" data-id="element-412" data-mp="3bynycbn030vr">
        <p data-id="element-413" data-mp="3py6t82qswfq4">
          © 2025 Maestro de Muebles Industriales. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-414" data-mp="3kwpvuh7izbea">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}